export const DEEP_BLUE = '#2474E8'
export const OPAC_GREEN = '#55A97A'
export const LIGHT_GRAY = '#8097A2'
export const ERROR = '#b33939'
